
import { api } from '../slices/api';

export const auditingApi = api.injectEndpoints({
    endpoints: (build) => ({
        postExportLedger: build.mutation<{ status: string; url: string }, { ledger_type: string; start_date?: string; end_date?: string }>({
            query: (body) => ({
                url: '/auditing/export/',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const { usePostExportLedgerMutation } = auditingApi;
